<template>
<div class="containers">
    <div class="search-area">
        <CRow>
            <CCol sm="6">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisibleUnit()"
                            @blur="toggleCloseVisibleUnit()"
                            v-model="queryUnit"
                            v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                            @keydown.up="upUnit"
                            @keydown.down="downUnit"
                            @keydown.enter="selectItemUnit"
                            placeholder="Pilih Unit"
                    >
                    <div class="popovers" v-show="visibleUnit">
                        <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesUnit"
                                :key="index"
                                :class="{ 'selected': (selectedUnit == index)}"
                                @click="itemClickedUnit(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol sm="4">
                <input 
                    class="form-control" 
                    v-model="tanggal"
                    type="date"
                />
            </CCol>
            <CCol sm="2">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6"></CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                <img class="mr-5 mt-1" style="float:right" :src="moreIcon" width="20px" height="20px"/>
                <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:right"/>
            </CCol>
        </CRow>
    </div>
    <Tables @sort="sorting" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
</div>
</template>

<script>
import Tables from '../../../component/tableHoliday'
import {DataApi} from "../../../service/DataApi";
export default {
    components: {
        Tables
    },
    data() {
        return {
            itemHeight: 39,

            // data search select unit
            dataUnit: [],
            titleUnit:"Pilih Unit",
            selectedItemUnit: null,
            selectedUnit: 0,
            queryUnit: '',
            visibleUnit: false,
            idUnit: '',
            
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Tanggal', 'Hari', 'Hari Libur'],
            dataTd: ['tanggal', 'hari', 'keterangan'],
            styleTable: ['140px', '140px', '800px'],
            classReload: 'reloadOff',

            // pagination
            page: 1,
            size: 100,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,
            
            // datas
            datas: [],
            dataParentUnitName: [],
            tanggal: '',


            //error
            errorMessage: '',
        }
    },
    computed: {
        matchesUnit() {
            if (this.queryUnit == '') {
                return [];
            }
            return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
        },
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryUnit() {
            if(this.queryUnit == '') {
                this.idUnit = ''
            }
            this.flagSearch = true
            this.getDataUnit()
        },
        tanggal() {
            this.flagSearch = true
        }
    },
    methods: {
        /**
         * SEARCH SELECT UNIT
         */
        getDataUnit() {
            let payload = {
                limit: 10,
                namaUnit: this.queryUnit,
                pageIn: 1,
                namaParentUnit: '',
                idUnit: ''
            }
            DataApi.post("unit/get", payload)
            .then(res => {
                this.dataUnit = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].id,
                        text: tempData[i].bidang
                    }
                    this.dataUnit.push(onPush)
                }
            })
        },

        toggleVisibleUnit() {
            this.visibleUnit = true;
        },
        hideUnit() {
            this.visibleUnit = false;
        },
        toggleCloseVisibleUnit() {
            setTimeout(this.hideUnit, 1000);
        },
        itemClickedUnit(index) {
            this.selectedUnit = index;
            this.selectItemUnit();
        },
        selectItemUnit() {
            if (!this.matchesUnit.length) {
            return;
            }
            this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
            this.visibleUnit = false;
            this.queryUnit = this.selectedItemUnit.text
            this.idUnit = this.selectedItemUnit.value
            if (this.shouldReset) {
            this.queryUnit = '';
            this.selectedUnit = 0;
            }
        },
        upUnit() {
            if (this.selectedUnit == 0) {
            return;
            }
            this.selectedUnit -= 1;
            this.scrollToItemUnit();
        },
        downUnit() {
            if (this.selectedUnit >= this.matchesUnit.length - 1) {
            return;
            }
            this.selectedUnit += 1;
            this.scrollToItemUnit();
        },
        scrollToItemUnit() {
            this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
        },
        
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.tanggal.toLowerCase() < b.tanggal.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggal.toLowerCase() > b.tanggal.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.hari.toLowerCase() < b.hari.toLowerCase()) {
                        return -1
                    }
                    if (a.hari.toLowerCase() > b.hari.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.keterangan.toLowerCase() < b.keterangan.toLowerCase()) {
                        return -1
                    }
                    if (a.keterangan.toLowerCase() > b.keterangan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let tanggal = this.tanggal
            let page = this.page
            let level = this.idUnit

            let payload = {
                level: level,
                limit: limit,
                tanggal: tanggal,
                pageIn: page,
            }
            DataApi.post("kalender/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.tanggal = ''
            this.queryUnit = ''
            this.idUnit = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        findData() {
            this.getData()
        }

    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataUnit()
    },
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    float: left;
    width: 100%;
    margin-left: 4px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: left;
    width: 100%;
    margin-left: 4px;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>